import { useEcomStore } from '@/data';
import { EnumCustomerType } from '@/types';

const useDeepLinkCustomerType = () => {
  const [, setStoredState] = useEcomStore();

  const deepLinkCustomerType = (customerType?: EnumCustomerType) => {
    if (!customerType) return;

    setStoredState({
      customer_type: customerType,
    });
  };

  return { deepLinkCustomerType };
};

export { useDeepLinkCustomerType };
